// Component specific props
export interface BadgeProps {
  title: string;
  Icon?: JSX.Element;
  classes?: string;
  titleClasses?: string;
  iconClasses?: string;
  iconOrder?: 'left' | 'right';
  bgColor?: string;
  txtColor?: string;
  // onClick?: VoidFunction;
}

export interface ExerciseStepsProps {
  onSubmit: VoidFunction;
  onBackEdit?: VoidFunction;
}

// Common props
export interface ActionCallbacks {
  onSuccess?: (result?: string) => void;
  onError?: (result?: string) => void;
}

// Generated exercise
export interface GenerateExerciseProps extends ActionCallbacks {
  title: string;
  description: string;
  prompts: string[];
  patientId: string;
}

export interface GeneratedExerciseData {
  title: string;
  description: string;
  questions: string[];
  prompts: string[];
  patientId: string;
}

// Preview Exercise
export interface PreviewExerciseType {
  title: string;
  description: string;
  questions: {
    question: string;
  }[];
  patientId: string;
}

// Save Exercise
export interface SaveExerciseProps extends ActionCallbacks {
  title: string;
  description: string;
  questions: string[];
  topics: string[];
  patientId: string;
}

export interface GeneratedExerciseResponse {
  questions: string[];
}

export enum ExerciseStatus {
  recommended = 'recommended',
  new = 'new',
  completed = 'completed',
  draft = 'draft',
}

export interface ExerciseType {
  _id?: string;
  title: string;
  topics: string[];
  description: string;
  questions: {
    _id: string;
    question: string;
    answer: string;
  }[];
  status: string;
  generatedByAi?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export type ExercisesPaginationType = {
  currentPage: number;
  hasNextPage: boolean;
  totalExercises: number;
  nextPage: number;
};

export enum ExerciseState {
  completed = 'completed',
  viewed = 'viewed',
  sent = 'sent',
  draft = 'draft',
  new = 'new',
}

export interface FormDataType {
  [key: string]: string[];
}

export interface GenerateFormDataType {
  title: string;
  description: string;
  prompts: FieldOptionsType[];
}

export interface FieldOptionsType {
  label: string;
  value: string;
}

export interface ExerciseQuestionsValidationProps {
  title: string;
  description: string;
  questions: {
    question: string;
  }[];
}

// Update exercise answers
export interface UpdateExerciseAnswersType extends ActionCallbacks {
  exerciseId: string;
  answers: {
    _id: string;
    answer: string;
  }[];
}
